import { countrySchema } from "@redotech/redo-platform-common/geographic-unit";
import * as z from "zod";

export const getCountries = {
  name: "getCountries" as const,
  input: z.null(),
  output: z.array(countrySchema),
};
